import classNames from 'classnames';
import React, { useState } from 'react';
import Box, { BoxProps } from 'ui-box';
import { defaultColors } from '.';

export interface ISpinnerProps extends BoxProps<any> {
  size?: number;
  value?: number | null;
}

export const Spinner: React.FC<ISpinnerProps> = ({
  className,
  size = 32,
  value = null,
  ...props
}) => {
  const strokeWidth = size >= 24 ? 4 : 2;

  const startMid = (-size / 2).toFixed(0);
  const viewBox = `${startMid} ${startMid} ${size} ${size}`;

  const [path, setPath] = useState<SVGPathElement | null>(null);

  const pathLength = path ? path.getTotalLength() : 0;
  // Radius
  const r = size / 2 - strokeWidth / 2;

  const track = `M ${0},${0} m 0,-${r} a ${r},${r} 0 1 1 0,${
    r * 2
  } a ${r},${r} 0 1 1 0,-${r * 2}`;

  const strokeOffset =
    pathLength -
    pathLength * (value === null ? 0.25 : Math.max(Math.min(value, 1), 0));

  return (
    <Box
      display="inline-flex"
      {...props}
      width={size}
      height={size}
      className={classNames(className)}
    >
      <svg
        width={size}
        height={size}
        strokeWidth={strokeWidth}
        viewBox={viewBox}
      >
        <path
          ref={setPath}
          d={track}
          stroke={'rgba(20, 20, 20, 0.15)'}
          fill="none"
        />
        {path && (
          <path
            d={track}
            stroke={defaultColors.gray[500]}
            fill="none"
            pathLength={pathLength}
            strokeDasharray={`${pathLength.toFixed(0)} ${pathLength.toFixed(
              0
            )}`}
            strokeDashoffset={strokeOffset}
          >
            {value === null && (
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 0 0"
                to="360 0 0"
                dur="0.8s"
                repeatCount="indefinite"
              />
            )}
          </path>
        )}
      </svg>
    </Box>
  );
};
